import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { bridgeLogout } from 'slices/BridgeSlice';
import { userSignOut } from 'actions/Auth';
import LanguageButton from '../LanguageSwitcher/LanguageButton';
import IntlMessages from '../../util/IntlMessages';
import { useShellAppContext } from '../../features/shell/context/useShellAppContext';
import { useLocalizedMessage } from '../../util/useLocalizedMessage';
import './user-controls.scss';

const UserControls = ({ showLogout = true }) => {
  const dispatch = useDispatch();
  const t = useLocalizedMessage();
  const isCompactMode = useSelector(({ app }) => app.isCompactMode);
  const { withdrawTelemetry } = useShellAppContext();

  const handleLogout = useCallback(async () => {
    try {
      await withdrawTelemetry();
    } catch (_error) {
      // Revocation is best-effort; local authority is already cleared.
    } finally {
      if (isCompactMode) {
        // Embedded mode: use bridge to logout
        dispatch(bridgeLogout());
      } else {
        // Normal mode: regular sign out
        dispatch(userSignOut());
      }
    }
  }, [dispatch, isCompactMode, withdrawTelemetry]);

  return (
    <div className="user-controls">
      <LanguageButton />
      {showLogout && (
        <>
          <Divider orientation="vertical" flexItem className="user-controls-divider" />
          <Tooltip title={<IntlMessages id="sidebar.account.logout" />} placement="bottom">
            <IconButton
              color="inherit"
              onClick={handleLogout}
              aria-label={t('sidebar.account.logout')}
              className="user-controls-logout"
            >
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </>
      )}
    </div>
  );
};

UserControls.propTypes = {
  showLogout: PropTypes.bool,
};

export default UserControls;
